// Importing required modules from the 'three' library and custom components
import * as THREE from 'three'
import Camera from './components/Camera'
import Control from './components/Control'
import EventDispatcher from './common/EventDispatcher'
import GUI from './components/GUI'
import Lights from './components/Lights';
import AssetLoader from './components/AssetLoader';
import GameScene from './components/GameScene';
import {
    Global
} from './common/global';
import GameControl from './components/GameControl'
import {
    RGBELoader
} from 'three/examples/jsm/loaders/RGBELoader.js'
import {
    v4 as uuidv4
} from 'uuid';
import {shuffle} from './common/array-util';
import * as swearjar from 'swearjar';
import * as leoProfanity from 'leo-profanity';


import './style.scss';
// import { WEBGL } from 'three/examples/jsm/WebGL.js';

// Importing mobile device detection functions
import {
    isMobile,
    isMobileOnly
} from 'mobile-device-detect';

// Importing additional components
import PlayerCar from './components/PlayerCar'
import Map from './components/Map'
import AICar from './components/AICar'
import Countdown from './components/Countdown'
import Sounds from './components/Sounds'
import {
    laneInfo
} from './common/lanes'
import {
    createUser,
    saveGameData,
    updateClick,
    updateGameData,
    registerUser,
    getLeaderData
} from './common/api'

// Variables to track time, frame rate, and delta time
let lastTime = 0;
let fps = 0;
let frameCount = 0;
let lastDeltaVec = new THREE.Vector3();

let EVCars = [{
        "name": "SEAL",
        "modelKey": "EVCar1",
        'image_key': 'car_seal',
        'efficiency': '183 Wh/km',
        'range': '330 Km',
        'battery': '60.5 kWh'
    },
    {
        "name": "ATTO",
        "modelKey": "EVCar2",
        'image_key': 'car_atto',
        'efficiency': '173 Wh/km',
        'range': '320 Km',
        'battery': '50.5 kWh'
    },
    {
        "name": "DOLPHIN",
        "modelKey": "EVCar3",
        'image_key': 'car_dolphin',
        'efficiency': '163 Wh/km',
        'range': '310 Km',
        'battery': '40.5 kWh'
    }
]

// Game class definition, extending THREE.Scene
export default class Game extends THREE.Scene {
    // Properties for environment map and screen sizes
    environmentMap = null;
    sizes = {
        width: window.innerWidth,
        height: window.innerHeight
    }

    // Constructor sets up event listener for window resize
    constructor() {
        super();
        window.addEventListener('resize', this.onResize.bind(this))
        
        document.querySelector("#pauseBtn").addEventListener("click", this.pauseGame.bind(this))
        document.querySelector("#volumeTrigger").addEventListener("click", this.updateSounds.bind(this))

        document.querySelector("#intro_scr video").addEventListener("ended", this.showCarSelection.bind(this, true,false))
        //showCarSelection
    }

    // Initialization method for setting up the game
    init() {
        Global.sizes=this.sizes
        Global.gamePaused=false;
        Global.gameTry = 1;
        Global.userRegistered = false;
        Global.controlType = null;
        this.gameTime = 0;
        this.leaderType=null;
        this.sortType=null;
        // Setting up performance statistics display
        this.fullScreenTO = null;
        // this.stats = new Stats();
        // this.stats.showPanel(0);
        // document.body.appendChild(this.stats.dom);

        // Initializing event dispatcher for handling events
        this.events = EventDispatcher.getObj();
        this.events.addEventListener("LOADER_EVENTS", this.onEvents.bind(this));
        this.events.addEventListener("GAME_EVENTS", this.onGameEvents.bind(this));
        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));

        // Getting the canvas element and initializing the clock
        this.canvas = document.querySelector('canvas.webgl');
        this.clock = new THREE.Clock();

        // Initializing GUI, camera, map, game scene, player car, lights, and game control
        this.gui = new GUI();
        this.gui.init();

        this.camera = new Camera(this,50, this.sizes.width / this.sizes.height, 0.1, 400);
        this.camera.init();
        this.add(this.camera);


        this.skyboxCamera = new Camera(this,50, this.sizes.width / this.sizes.height, 10, 1000);
        this.skyboxCamera.init();
        this.add(this.skyboxCamera);

        this.skyboxCamera.layers.set(100);

     



        this.createLevel();
  

        this.gameSounds = new Sounds(this, this.camera);
        this.gameSounds.init();
        this.gameControl = new GameControl(this);
        this.gameControl.init();

        this.renderer = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            precision: 'highp',
            powerPreference: 'high-performance'
        });


        this.renderer.setClearColor(0x000000, 0);
        this.renderer.gammaFactor = 2.2
        this.renderer.useLegacyLights = false;
        this.renderer.setSize(this.sizes.width * 1, this.sizes.height * 1)
        this.renderer.setPixelRatio(Math.min(Math.max(2, window.devicePixelRatio), isMobile ? 1.5 : 2.0));
        this.renderer.autoClear = false;
        this.assetLoader = new AssetLoader(this);
        this.assetLoader.init();

        this.onResize();
        this.tick();
 
        const rgbeLoader = new RGBELoader()
        rgbeLoader.load('https://www.jimmysarcade.co.uk/textures/environmentMaps/1/city.hdr', (environmentMap) => {
            environmentMap.mapping = THREE.EquirectangularReflectionMapping
            Global.envMap = environmentMap;
            this.environment = environmentMap
            this.assetLoader.prepare();
        })

    }
    AddAICars() {
        const totalCars = (Global.gameLevel == 1 ? 65 : Global.gameLevel == 2 ? 75 : 85); // Total cars based on game level
        const lanes = 5; // Total lanes (including lane 5)
        const laneDistribution = [0.3, 0.15, 0.1, 0.15, 0.3]; // Distribution percentages for lanes 1 to 5
        let carsPerLane = laneDistribution.map(percent => Math.round(totalCars * percent)); // Calculate cars per lane
    
        // Randomly select a lane to avoid
        const laneToAvoid = Math.floor(Math.random() * 5); // Random lane index (0 to 4)
        // console.log(`Avoiding lane: ${laneToAvoid + 1}`); // Log the lane being avoided
    
        // Redistribute the cars from the avoided lane to the other lanes
        const carsToRedistribute = carsPerLane[laneToAvoid];
        carsPerLane[laneToAvoid] = 0; // Set the avoided lane to 0 cars
    
        // Distribute the extra cars evenly among the remaining lanes
        const remainingLanes = lanes - 1;
        const extraCarsPerLane = Math.floor(carsToRedistribute / remainingLanes);
        let remainingExtraCars = carsToRedistribute % remainingLanes;
    
        for (let i = 0; i < lanes; i++) {
            if (i !== laneToAvoid) {
                carsPerLane[i] += extraCarsPerLane;
                if (remainingExtraCars > 0) {
                    carsPerLane[i]++;
                    remainingExtraCars--;
                }
            }
        }
    
        // Initialize lane distances
        let laneDistances = Array(lanes).fill(0).map(() => (Global.gameLevel == 3 ? 0.03 : 0.05) + (Math.random() * (Global.gameLevel == 3 ? 0.01 : 0.02)));
    
        // Initialize and shuffle the car array
        let initCars = [];
        for (let i = 1; i <= totalCars; i++) {
            if (i <= 3) {
                initCars.push(0.0005); // Initial cars with a specific value
            } else {
                initCars.push(1); // Normal cars
            }
        }
        initCars = shuffle(initCars);
    
        // Initialize the first few cars manually (if needed)
        let carIndex = 0;
        this.AILane1Car1a = new AICar(this);
        this.AILane1Car1a.init(
            1,
            `AICar1`,
            .0005,//Global.gameLevel == 1 ? .00105 : .00095,
            Math.max(0.4, Math.random()) * 0.00035 * (isMobile ? 0.75 : 1),
            1
        );
        this.AILane1Car1b = new AICar(this);
        this.AILane1Car1b.init(
            1,
            `AICar2`,
            .0005,//Global.gameLevel == 1 ? .00105 : .00095,
            Math.max(0.4, Math.random()) * 0.00035 * (isMobile ? 0.75 : 1),
            2
        );
        this.AILane1Car1c = new AICar(this);
        this.AILane1Car1c.init(
            1,
            `AICar3`,
            .0005,//Global.gameLevel == 1 ? .00105 : .00095,
            Math.max(0.4, Math.random()) * 0.00035 * (isMobile ? 0.75 : 1),
            4
        );
        this.AILane1Car1d = new AICar(this);
        this.AILane1Car1d.init(
            1,
            `AICar4`,
            .0005,//Global.gameLevel == 1 ? .00105 : .00095,
            Math.max(0.4, Math.random()) * 0.00035 * (isMobile ? 0.75 : 1),
            5
        );
    
        // Add cars to lanes (excluding the avoided lane)
        for (let lane = 0; lane < lanes; lane++) {
            if (lane === laneToAvoid) continue; // Skip the avoided lane
    
            for (let i = 0; i < carsPerLane[lane]; i++) {
                if (carIndex >= totalCars) break; // Ensure we don't exceed the total car count
    
                const randomCarType = Math.floor(Math.random() * 5) + 1; // Random car type
                const speedMultiplier = Math.max(0.5, Math.random()) * 0.0004; // Slightly varied speed per car
    
                const vehicleKey=(Global.gameLevel==2 && Math.random()<.1)?'AIBus':(Global.gameLevel==3 && Math.random()<.1)?'AIVan':`AICar${randomCarType}`
                this[`AILane${lane + 1}Car${i}`] = new AICar(this);
                this[`AILane${lane + 1}Car${i}`].init(
                    ++carIndex,
                    vehicleKey,
                    laneDistances[lane],
                    speedMultiplier * (isMobile ? 0.75 : 1)*(['AIBus','AIVan'].indexOf(vehicleKey)!==-1?0.7:1),
                    lane + 1
                );
    
                // Progress lane distances but ensure they stay within 0.2 to 0.8 range
                laneDistances[lane] = Math.min(
                    laneDistances[lane] + (Global.gameLevel == 3 ? 0.02 : 0.03 + Math.random() * 0.025 * (
                        Global.gameLevel == 1 ? 1 : Global.gameLevel == 2 ? 0.2 : 0.1
                    )), 0.8
                );
            }
        }
    
    }
    // AddAICars() {
    //     const totalCars = (Global.gameLevel == 1 ? 75 : Global.gameLevel == 2 ? 90 : 100); // Total cars based on game level
    //     const lanes = 5; // Total lanes (including lane 5)
    //     const laneDistribution = [0.3, 0.15, 0.1, 0.15, 0.3]; // Distribution percentages for lanes 1 to 5
    //     const carsPerLane = laneDistribution.map(percent => Math.round(totalCars * percent)); // Calculate cars per lane
    
    //     let laneDistances = Array(lanes).fill(0).map(() => (Global.gameLevel == 3 ? 0.03 : 0.05) + (Math.random() * (Global.gameLevel == 3 ? 0.01 : 0.02))); // Initialize lane distances
    
    //     let initCars = [];
    //     for (let i = 1; i <= totalCars; i++) {
    //         if (i <= 3) {
    //             initCars.push(0.0005); // Initial cars with a specific value
    //         } else {
    //             initCars.push(1); // Normal cars
    //         }
    //     }
    //     initCars = shuffle(initCars); // Shuffle the car array
    
    //     let carIndex = 0;
    //     this.AILane1Car1a = new AICar(this);
    //     this.AILane1Car1a.init(
    //         1,
    //         `AICar1`,
    //         Global.gameLevel==1?.00105:.00095,
    //         Math.max(0.8, Math.random()) * 0.0002 * (isMobile ? 0.75 : 1),
    //         1
    //     );
    //     this.AILane1Car1b = new AICar(this);
    //     this.AILane1Car1b.init(
    //         1,
    //         `AICar2`,
    //         Global.gameLevel==1?.00105:.00095,
    //         Math.max(0.8, Math.random()) * 0.0002 * (isMobile ? 0.75 : 1),
    //         2
    //     );

    //     this.AILane1Car1c = new AICar(this);
    //     this.AILane1Car1c.init(
    //         1,
    //         `AICar3`,
    //         Global.gameLevel==1?.00105:.00095,
    //         Math.max(0.8, Math.random()) * 0.0002 * (isMobile ? 0.75 : 1),
    //         4
    //     );
        
    //     this.AILane1Car1d = new AICar(this);
    //     this.AILane1Car1d.init(
    //         1,
    //         `AICar4`,
    //         Global.gameLevel==1?.00105:.00095,
    //         Math.max(0.8, Math.random()) * 0.0002 * (isMobile ? 0.75 : 1),
    //         5
    //     );

    //     for (let lane = 1; lane <= lanes; lane++) {
    //         for (let i = 0; i < carsPerLane[lane - 1]; i++) {
    //             if (carIndex >= totalCars) break; // Ensure we don't exceed the total car count
    

    //             const randomCarType = Math.floor(Math.random() * 5) + 1; // Random car type
    //             const speedMultiplier = Math.max(0.5, Math.random()) * 0.0004; // Slightly varied speed per car
    
    //             this[`AILane${lane}Car${i}`] = new AICar(this);
    //             this[`AILane${lane}Car${i}`].init(
    //                 ++carIndex,
    //                 `AICar${randomCarType}`,
    //                 laneDistances[lane - 1],
    //                 speedMultiplier * (isMobile ? 0.75 : 1),
    //                 lane
    //             );
                
    //             // Progress lane distances but ensure they stay within 0.2 to 0.8 range
    //             laneDistances[lane - 1] = Math.min(
    //                 laneDistances[lane - 1] + (Global.gameLevel == 3 ? 0.02 : 0.03 + Math.random() * 0.025 * (
    //                     Global.gameLevel == 1 ? 1 : Global.gameLevel == 2 ? 0.2 : 0.1
    //                 )), 0.8
    //             );
    //         }
    //     }
    // }
    // AddAICars() {

    //     const totalCars = (Global.gameLevel==1?75:Global.gameLevel==2?100:140); // 100;
    //     const lanes = 4;
    //     const carsPerLane = Math.ceil(totalCars / lanes);
    //     const laneToAvoid= Math.floor(Math.random() * 5) + 1;
        
    //     let laneDistances = Array(lanes+1).fill(0).map(() => (Global.gameLevel==3?0.03:0.05) + (Math.random() * (Global.gameLevel==3?0.01:0.02))); // Ensuring values between 0.2 and 0.8
        
    //     let initCars=[];
    //     for(let i=1;i<=totalCars;i++){
    //         if(i<=3){
    //             initCars.push(0.0005)
    //         }else{
    //             initCars.push(1)
    //         }
            
    //     }
    //     initCars=shuffle(initCars);
    //     let carIndex=0;
    //     for (let i = 0; i <= carsPerLane; i++) {
    //         for (let lane = 1; lane <= lanes+1; lane++) {
    //             if (i * lanes + lane > totalCars) break; // Ensure the total car count does not exceed 100
    //             if(lane !== laneToAvoid){
    //                 const randomCarType = Math.floor(Math.random() * 5) + 1;
    //                 const speedMultiplier = Math.max(0.5, Math.random()) * 0.0004; // Slightly varied speed per car
    
    //                 this[`AILane${lane}Car${i}`] = new AICar(this);
    //                 this[`AILane${lane}Car${i}`].init(
    //                     ++carIndex,
    //                     `AICar${randomCarType}`,
    //                     (initCars[carIndex-1]==0.0005 && lane==3)?0:laneDistances[lane - 1] * (initCars[carIndex-1]),
    //                     speedMultiplier * (isMobile ? 0.75 : 1),
    //                     (initCars[carIndex-1]==0.0005 && lane==3)?lane+1:lane
    //                 );
    
    //                 // Progress lane distances but ensure they stay within 0.2 to 0.8 range
    //                 laneDistances[lane - 1] = Math.min(laneDistances[lane - 1] + (Global.gameLevel==3?0.02:.03 + Math.random() * 0.025*(
    //                     Global.gameLevel==1?1:Global.gameLevel==2?0.2:.1
    //                 )), 0.8);
    //             }
                

    //         }
    //     }
    // }
    prepareRoadLanes() {
        const scaleFactor = 20; // Since your scene is scaled 20x, we scale down by 1/20

        const _level = Global.gameLevel > 1 ? 2 : 1;
        for (let i = 1; i <= 5; i++) {
            let scaledPoints = laneInfo[`level${_level}`][`lane${i}`].map(point =>
                new THREE.Vector3(point.x * scaleFactor, point.y * scaleFactor, point.z * scaleFactor)
            )
            if (i != 5 || _level !== 1)
                scaledPoints = scaledPoints.reverse();
            // const geometry = new THREE.BufferGeometry().setFromPoints(scaledPoints);
            // const material = new THREE.LineBasicMaterial({ linewidth:10,color: 0xff0000,side: THREE.DoubleSide, depthTest:false,depthWrite:false });
            // const curveLine = new THREE.Line(geometry, material);
            // this.add(curveLine);
            Global[`AIPath${i}`] = new THREE.CatmullRomCurve3(scaledPoints);
            Global[`AIPath${i}`].curveType = 'catmullrom';
            Global[`AIPath${i}`].tension = 0.5;

        }


    }
    showScore() {
        this.hideAllScreen();
        document.querySelector("#score_scr").classList.add('active');
        setTimeout(() => {
            document.querySelector("#score_scr").classList.add('active2');
        }, 100)
        document.querySelectorAll("#score_scr .score_content .head .star").forEach((star) => {
            if (Global.placed) {
                star.classList.add('active');
            } else {
                star.classList.remove('active');
            }

        });
        document.querySelector("#score_scr .score_content .head .txt").innerHTML = Global.placed ? "WELL DONE" : "ALMOST THERE!";

        document.querySelector("#score_scr .score_content .info .info_time").innerHTML = Global.time;
        document.querySelector("#score_scr .score_content .info .info_model").innerHTML = `BYD ${EVCars[this.carIndex-1]['name']}`
        document.querySelector("#score_scr .score_content .info .info_rank").innerHTML = Global.rank;

    }


    resetRegister() {
        document.querySelector("#register_scr #fName").value = "";
        document.querySelector("#register_scr #lName").value = "";
        document.querySelector("#register_scr #mobile").value = "";
    }
    async doRegister() {
        if (Global.userRegistered) return false;

        let isValid = this.validateRegister();
        if (!isValid) return false;
        Global.userRegistered = true;

        // this.events.dispatchEvent({
        //     type: "SOUND_EVENTS",
        //     message: {
        //         "event_type": "play_sound",
        //         data: {
        //             'sndKey': 'click'
        //         }
        //     }
        // });

        await registerUser();
        this.showLeaderboard(true);

    }
    validateRegister() {


        let isValid = true;

        Global.userName = document.querySelector("#register_sec #name").value.trim();
        Global.email = document.querySelector("#register_sec #email").value.trim();

        if (Global.userName.length == 0) {
            document.querySelector("#register_sec #name").parentElement.classList.add("error");
            isValid = false;
        }else if(Global.userName.length !=0){
            if (
                swearjar.profane(Global.userName.replace(/\s/g, "")) ||
                leoProfanity.clean(Global.userName) !== Global.userName
            ) {
              document.querySelector("#register_sec #name").parentElement.classList.add("error")
              isValid = false;
          } else {
            document.querySelector("#register_sec #name").parentElement.classList.remove("error")
          }
             
          }
        if (Global.email.length == 0) {
            document.querySelector("#register_sec #email").parentElement.classList.add("error");
            isValid = false;
        }
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(Global.email))) {
            document.querySelector("#register_sec #email").parentElement.classList.add("error");
            isValid = false;
        } else if ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email))) {
            document.querySelector("#register_sec #email").parentElement.classList.remove("error")
        }
        if (!document.querySelector("#t_c_check").checked) {
            isValid = false;
            document.querySelector("#t_c_check").parentElement.classList.add("error")
        } else {
            document.querySelector("#t_c_check").parentElement.classList.remove("error")
        }

        return isValid;

    }
    showError(msg) {
        this.errorTO && clearTimeout(this.errorTO);
        document.querySelector('.register_error').classList.add('active')
        document.querySelector('.register_error').innerHTML = msg;
        this.errorTO = setTimeout(() => {
            document.querySelector('.register_error').classList.remove('active')
        }, 1500)
    }

    showStartCounter() {
        this.countDown = new Countdown(this, this.camera);
        this.countDown.init();
    }
    startGame() {
        // Global.playCount++;

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        document.querySelector(`#BGMusic1`).pause();
        document.querySelector(`#BGMusic2`).pause();
        document.querySelector(`#BGMusic3`).pause();
        document.querySelector(`#BGMusic${Global.gameLevel}`).currentTime=0;
        if(Global.soundEnabled){
            document.querySelector(`#BGMusic${Global.gameLevel}`).play();
        }

        if (isMobile && Global.controlType == "gyro") {
            this.events.dispatchEvent({
                type: "GAME_EVENTS",
                message: {
                    "event_type": "ask_permission",
                    data: {}
                }
            });
        } else {
            setTimeout(() => {
                this.showStartCounter();
            }, 3000)

        }

        this.events.dispatchEvent({
            type: "PLAYER_EVENTS",
            message: {
                "event_type": "add_car",
                data: {
                    'vehicleKey': Global.vehicleType
                }
            }
        });
        this.events.dispatchEvent({
            type: "GAME_EVENTS",
            message: {
                "event_type": "pan_camera",
                data: {
                }
            }
        });
        // if(Global.playCount==1){
        //     this.events.dispatchEvent({
        //         type: "PLAYER_EVENTS",
        //         message: {
        //             "event_type": "add_car",
        //             data: {
        //                 'vehicleKey': Global.vehicleType
        //             }
        //         }
        //     });
        // }else{
        //     this.events.dispatchEvent({
        //         type: "PLAYER_EVENTS",
        //         message: {
        //             "event_type": "update_player_car",
        //             data: {
        //                 'vehicleKey': Global.vehicleType
        //             }
        //         }
        //     });
        // }

        setTimeout(() => {
            // document.querySelector("#mode_selection").classList.remove("active");
        }, 500)

    }
    selectMode(controlType, btnId) {
        Global.controlType = controlType;
        document.querySelector("#mode_selection #mode1").classList.remove('active');
        document.querySelector("#mode_selection #mode2").classList.remove('active');
        document.querySelector(`#mode_selection #${btnId}`).classList.add('active');
        document.querySelector(`#mode_selection .sec2 img`).src = `ui/${btnId}.gif`
    }
    hideModeSelection() {

    }
    showHome() {
        this.hideAllScreen();

        this.gameTime = 0;
        Global.gameOver = false;
        this.userRegistered = false;
        // document.querySelector("#info_time .txt").innerHTML = `00:00`

        // this.activateFullscreenToggle();
        document.querySelector("#home_scr").classList.add('active');
        /* this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "stop_sound",
                data: {
                    'sndKey': 'game'
                }
            }
        }); */
        /* this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'splash'
                }
            }
        }); */
    }
    hideDialog(){
        document.querySelector(`#dialog_screen .level${Global.gameLevel}_dialog1`).classList.remove("active")
        document.querySelector(`#dialog_screen .level${Global.gameLevel}_dialog2`).classList.remove("active")
        document.querySelector(`#dialog_screen .level${Global.gameLevel}_dialog3`).classList.remove("active")
    }
    showLevelCompleteDialog(){
        this.hideAllScreen();
        document.querySelector("#dialog_screen").classList.add("active");
        setTimeout(()=>{
            document.querySelector("#dialog_screen").classList.add("active2")
        },0);

        let dialogIndex=0.5
        this.dialogInt=setInterval(() => {
            dialogIndex+=0.5;
            
            if(Math.floor(dialogIndex)<=3 && dialogIndex == Math.floor(dialogIndex)){
                this.hideDialog();
                document.querySelector(`#dialog_screen .level${Global.gameLevel}_dialog${dialogIndex}`).classList.add("active")

            }else if(dialogIndex>3){
                setTimeout(()=>{
                    clearInterval(this.dialogInt)
                    this.hideDialog();
                    document.querySelector("#dialog_screen").classList.remove("active2")
                },900)
                setTimeout(()=>{
                    document.querySelector("#dialog_screen").classList.remove("active")
                    this.showLevelCompleted();
                },1500)
            }
            
        }, 1000);
     
    }
    hideHome() {
        document.querySelector("#home_scr").classList.remove('active');
    }
    hideAllScreen() {

        document.querySelector("#dialog_screen").classList.remove("active")
        document.querySelector("#splash_scr").classList.remove('active');
        document.querySelector("#home_scr").classList.remove('active');
        document.querySelector("#how_to_play").classList.remove('active');
        document.querySelector("#selection_scr").classList.remove('active');
        document.querySelector("#level_complete_scr").classList.remove('active');
        document.querySelector("#level_complete_scr").classList.remove('active2');
        document.querySelector("#score_scr").classList.remove('active')
        document.querySelector("#score_scr").classList.remove('active2')
        document.querySelector("#leaderboard").classList.remove('active')
        document.querySelector("#register_sec").classList.remove('active')
        document.querySelector("#intro_scr").classList.remove('active');

        if(!document.querySelector("#intro_scr video").paused){
            document.querySelector("#intro_scr video").pause();
        }
    }
    hideInstruction(){
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        document.querySelector("#how_to_play").classList.remove('active');
    }
    showInstruction(isMainInstruction) {
        if (Global.vehicleType == null) return false;

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        if(isMainInstruction){
            updateClick("vehicleSelectClick")
        }
       
        this.hideAllScreen();
        document.querySelector("#how_to_play").classList.add('active');

        if(!isMainInstruction){
            document.querySelector("#how_to_play").classList.add('no-bg');
        }else{
            document.querySelector("#how_to_play").classList.remove('no-bg');
        }

    }
    async showCarSelection(disableCards, playSnd) {
        updateClick("letsgoClick")
        
        if(playSnd){
            this.events.dispatchEvent({
                type: "SOUND_EVENTS",
                message: {
                    "event_type": "play_sound",
                    data: {
                        'sndKey': 'click'
                    }
                }
            });
        }
       
        if(disableCards){
            Global.vehicleType=null;
            document.querySelectorAll("#selection_scr .cards .card").forEach((card)=>{
                card.classList.remove("active")
            })
        }
      
        this.hideAllScreen();
        document.querySelector("#selection_scr").classList.add('active');


        //
        // this.pickCar(1);

        // let sessionRes= await createSession();
        // Global.sessionId= sessionRes.id;
        // console.log(Global.sessionId,'sessionRes')
    }
    pickCar(carIndex) {
        this.carIndex += carIndex;
        /* this.carIndex= Math.max(1, this.carIndex);
        this.carIndex= Math.min(3, this.carIndex); */

        /*  document.querySelector("#nav_left").classList.add('active');
         document.querySelector("#nav_right").classList.add('active'); */
        if (this.carIndex < 1) {
            this.carIndex = 3;
            // document.querySelector("#nav_left").classList.remove('active');
        }
        if (this.carIndex > 3) {
            this.carIndex = 1
            // document.querySelector("#nav_right").classList.remove('active');
        }
        document.querySelector('.car_title').innerHTML = `BYD ${EVCars[this.carIndex-1]['name']}`;
        document.querySelector('.car_view img').src = `ui/${EVCars[this.carIndex-1]["image_key"]}.png`

        document.querySelector('#selection_scr .detail_efficiency .label .head').innerHTML = EVCars[this.carIndex - 1]['efficiency'];
        document.querySelector('#selection_scr .detail_range .label .head').innerHTML = EVCars[this.carIndex - 1]['range'];
        document.querySelector('#selection_scr .detail_battery .label .head').innerHTML = EVCars[this.carIndex - 1]['battery'];

    }
    async showLeaderData() {
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        this.hideAllScreen();
        document.querySelector("#leader_scr").classList.add('active');
        document.querySelector('#leader_scr .info').innerHTML = '';

        let leaderData = await leaderBoard();
        document.querySelector("#leader_scr>.container").classList.add('active');
        leaderData.forEach((data, index) => {
            if (index < 5) {
                document.querySelector('#leader_scr .info').innerHTML += `
                <div class="card ${Global.rank==data.rank?'self':''}">
                        <div class="info_rank">${data.rank}</div>
                        <div class="info_player">${data.display_name}</div>
                        <div class="info_model">BYD ${data.car_model}</div>
                        <div class="info_time">${data.time}</div>
                    </div>
            `;
            }

        })

    }
    fillLeaderData(leaderType, category){

        if(leaderType == 'weekly'){
            document.querySelector("#leaderboard .title_weekly").classList.add("active");
            document.querySelector("#leaderboard .title_all").classList.remove("active");
        }else{
            document.querySelector("#leaderboard .title_weekly").classList.remove("active");
            document.querySelector("#leaderboard .title_all").classList.add("active");
        }

        document.querySelector(`#leaderboard .sub_title #All`).classList.remove("active");
        document.querySelector(`#leaderboard .sub_title #Truck`).classList.remove("active");
        document.querySelector(`#leaderboard .sub_title #Bike`).classList.remove("active");
        document.querySelector(`#leaderboard .sub_title #Car`).classList.remove("active");

        document.querySelector(`#leaderboard .sub_title #${category}`).classList.add("active");
        
        this.leaderType=leaderType;
        this.sortType=category;
        
        const leaderData= this.leaderData[leaderType][category];
        document.querySelector("#leaderboard .leader_sec").innerHTML='';
        document.querySelector("#leaderboard .self").innerHTML='';
        document.querySelector("#leaderboard .self").classList.remove('active')
        document.querySelector("#leaderboard .container").classList.add('active')
        let existsOnTop=false;

        leaderData.top.forEach((top, index)=>{
            if(top.uid===localStorage.getItem('uuid')){
                existsOnTop= true;
            }
            const elapsed = {
                minutes: 0,
                seconds: 0,
                milliseconds: 0
            };
            elapsed.minutes = Math.floor(top.time / 60); // Convert to minutes
            elapsed.seconds = Math.floor((top.time % 60)); // Get remaining seconds
            elapsed.milliseconds = Math.round((top.time % 1) * 1000);
            if(elapsed.milliseconds>100){
                elapsed.milliseconds= Math.floor(elapsed.milliseconds/10);
            }

            const entry=`
                <div class="${top.uid==localStorage.getItem('uuid')?'leader active':'leader'}">
                            <div class="rank">
                                <img src="https://www.jimmysarcade.co.uk/ui/Leader/rank${top.rank==0?'1':top.rank==1?'2':'3+'}.png" alt="" srcset=""> <span class="label">#${top.rank}</span>
                            </div>
                            <div class="name">${top.name}</div>
                            <div class="time">${`${elapsed.minutes<10?'0':''}${elapsed.minutes}:${elapsed.seconds<10?'0':''}${elapsed.seconds}:${elapsed.milliseconds<10?'0':''}${elapsed.milliseconds}`}</div>
                        </div>
            `;
            // console.log(entry,'entry')
            document.querySelector("#leaderboard .leader_sec").insertAdjacentHTML("beforeend", entry);
        });
        if(!existsOnTop && leaderData.self !==null){
            const elapsed = {
                minutes: 0,
                seconds: 0,
                milliseconds: 0
            };
            elapsed.minutes = Math.floor(leaderData.self.time / 60); // Convert to minutes
            elapsed.seconds = Math.floor((leaderData.self.time % 60)); // Get remaining seconds
            elapsed.milliseconds = Math.round((leaderData.self.time % 1) * 1000);
            if(elapsed.milliseconds>100){
                elapsed.milliseconds= Math.floor(elapsed.milliseconds/10);
            }
            document.querySelector("#leaderboard .self").classList.add('active')
        const selfEntry=`
              <div class="rank">
                                <img src="https://www.jimmysarcade.co.uk/ui/Leader/rank3+.png" alt="" srcset=""> <span class="label">#${leaderData.self.rank}</span>
                            </div>
                            <div class="name">${top.name}</div>
                            <div class="time">${`${elapsed.minutes<10?'0':''}${elapsed.minutes}:${elapsed.seconds<10?'0':''}${elapsed.seconds}:${elapsed.milliseconds<10?'0':''}${elapsed.milliseconds}`}</div>
            `;
            document.querySelector("#leaderboard .self").insertAdjacentHTML("beforeend", selfEntry);
        }

    }
    async showLeaderboard(hideBack) {
        updateClick("leaderboardClick")

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });

        if(hideBack){
            document.querySelector("#leaderboard #leaderBack").classList.remove('active');
            document.querySelector("#leaderboard #replayBtn").classList.add('active');
        }else{
            document.querySelector("#leaderboard #leaderBack").classList.add('active');
            document.querySelector("#leaderboard #replayBtn").classList.remove('active');
        }
        this.hideAllScreen();
        document.querySelector("#leaderboard").classList.add('active');
        document.querySelector("#leaderboard .container").classList.remove('active')
        this.leaderData= await getLeaderData();

        this.fillLeaderData("weekly", "All");

       
   
    }
    showRegisterScreen() {
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        updateClick("signupClick")
        this.hideAllScreen();

        document.querySelector("#register_sec #name").parentElement.classList.remove("error");
        document.querySelector("#register_sec #name").parentElement.classList.remove("error");
        document.querySelector("#t_c_check").parentElement.classList.remove("error");
        document.querySelector("#register_sec").classList.add('active')

    }

    showScoreScreen() {
        this.hideAllScreen();

        const totalTime = Global.level1Time + Global.level2Time + Global.level3Time;
       
        let elapsed = {
            minutes: 0,
            seconds: 0,
            milliseconds: 0
        };
        elapsed.minutes = Math.floor(totalTime / 60); // Convert to minutes
        elapsed.seconds = Math.floor((totalTime % 60)); // Get remaining seconds
        elapsed.milliseconds = Math.round((totalTime % 1) * 1000);
        if(elapsed.milliseconds>100){
            elapsed.milliseconds= Math.floor(elapsed.milliseconds/10);
        }
        // console.log(elapsed,'elapsed',totalTime);
        document.querySelector("#score_scr .score_sec").innerHTML = `${elapsed.minutes<10?'0':''}${elapsed.minutes}:${elapsed.seconds<10?'0':''}${elapsed.seconds}:${elapsed.milliseconds<10?'0':''}${elapsed.milliseconds}`

        if (Global.userRegistered) {
            document.querySelector("#score_scr #signupNow").classList.remove("active");
            document.querySelector("#score_scr #replayBtn").classList.add("active");
            document.querySelector("#score_scr #leaderBtn").classList.add("active");
        } else {
            document.querySelector("#score_scr #signupNow").classList.add("active");
            document.querySelector("#score_scr #replayBtn").classList.add("active");
            document.querySelector("#score_scr #leaderBtn").classList.remove("active");
        }

        document.querySelector("#score_scr").classList.add('active')
        setTimeout(() => {
            document.querySelector("#score_scr").classList.add('active2')
        }, 1000);
        setTimeout(() => {
            Global.boostActivated = false;
            Global.invinsibleActivated = false;
            document.querySelector(".game_header").classList.remove('active')
            // document.querySelector("#miniMap").classList.remove('active')
            this.events.dispatchEvent({
                type: "GAME_EVENTS",
                message: {
                    "event_type": "dispose",
                    data: {

                    }
                }
            });
        }, 2000);
    }
    showLevelCompleted() {

        this.hideAllScreen()

        if(Global.gameLevel!==3){
            document.querySelector("#level_complete_scr #nextLevel").classList.add("active");
            document.querySelector("#level_complete_scr #yourScore").classList.remove("active");
        }else{
            document.querySelector("#level_complete_scr #nextLevel").classList.remove("active");
            document.querySelector("#level_complete_scr #yourScore").classList.add("active");
        }
        document.querySelector("#level_complete_scr").classList.add('active')
        setTimeout(() => {
            document.querySelector("#level_complete_scr").classList.add('active2')
        }, 1000)
    }
    showSplash() {
        this.hideAllScreen();



        document.querySelector("#splash_scr").classList.add('active');
    }

    // showSplashBtn() {
    //     document.querySelector("#splashPlay").classList.add('active');
    //     document.querySelector('.loading_progress').classList.remove('active');
    //     setTimeout(() => {
    //         this.showHome();
    //         // this.showCarSelection();
    //         //    this.onStart();
    //         // this.showLeaderboard();
    //     }, 100)
    // }
    onSplashProceed() {
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });


    }
    onStart() {
        this.hideAllScreen();
        document.querySelector("#game_view").classList.add("active")
        this.startGame();
    }
    initBtns() {
        document.querySelectorAll("#selection_scr .cards .card").forEach((card) => {
            card.addEventListener("click", this.onCardSelected.bind(this, card))
        })
        
        // document.querySelector(".t_c_trigger").addEventListener("click", ()=>{
        //     $("#policy_en").modal('show')
        // });

        document.querySelector("#home_scr #letsGo").addEventListener("click", this.showIntro.bind(this));
        document.querySelector("#how_to_play #resumeBtn").addEventListener("click", this.resumeGame.bind(this));
        document.querySelector("#how_to_play #homeBtn").addEventListener("click", this.gotoHome.bind(this));
        document.querySelector("#how_to_play #gotoWeb").addEventListener("click", this.quitGame.bind(this));
        document.querySelector("#how_to_play #restartGameBtn").addEventListener("click", this.restartGame.bind(this));
        
        document.querySelector("#intro_scr #introSkip").addEventListener("click", this.showCarSelection.bind(this, true, true));
        document.querySelector("#selection_scr #leaderBtn2").addEventListener("click", this.showLeaderboard.bind(this, false, true));
        document.querySelector("#selection_scr #selectBtn").addEventListener("click", this.showInstruction.bind(this, true));
        document.querySelector("#how_to_play #startBtn").addEventListener("click", () => {
            updateClick("startClick");
            this.onStart()
            this.events.dispatchEvent({
                type: "SOUND_EVENTS",
                message: {
                    "event_type": "play_sound",
                    data: {
                        'sndKey': 'click'
                    }
                }
            });
        });
        document.querySelector("#level_complete_scr #couponCopy").addEventListener("click", this.copyCodeToClipboard.bind(this));
        document.querySelector("#level_complete_scr #nextLevel").addEventListener("click", this.playNextLevel.bind(this));
        document.querySelector("#level_complete_scr #yourScore").addEventListener("click", this.showScoreScreen.bind(this));

        document.querySelector("#score_scr #signupNow").addEventListener("click", this.showRegisterScreen.bind(this));
        document.querySelector("#score_scr #replayBtn").addEventListener("click", this.replayGame.bind(this, true));
        document.querySelector("#leaderboard #replayBtn").addEventListener("click", this.replayGame.bind(this, true));
        document.querySelector("#leaderboard #leaderBack").addEventListener("click", this.showCarSelection.bind(this, false, true));
        document.querySelector("#score_scr #leaderBtn").addEventListener("click", this.showLeaderboard.bind(this, true));
        document.querySelector("#register_sec #submitBtn").addEventListener("click", this.doRegister.bind(this));
        document.querySelector("#register_sec #registerReplay").addEventListener("click", this.replayGame.bind(this, true));


        document.querySelector("#leaderboard .title_weekly").addEventListener("click", ()=>{
            this.fillLeaderData("weekly", this.sortType||"All")
        });
        document.querySelector("#leaderboard .title_all").addEventListener("click",()=>{
            this.fillLeaderData("all_time", this.sortType||"All")
        });

        document.querySelector("#leaderboard #All").addEventListener("click", ()=>{
            this.fillLeaderData(this.leaderType, "All")
        });
        document.querySelector("#leaderboard #Truck").addEventListener("click",()=>{
            this.fillLeaderData(this.leaderType, "Truck")
        });
        document.querySelector("#leaderboard #Bike").addEventListener("click",()=>{
            this.fillLeaderData(this.leaderType, "Bike")
        });
        document.querySelector("#leaderboard #Car").addEventListener("click",()=>{
            this.fillLeaderData(this.leaderType, "Car")
        });
    }
    showIntro(){
        this.hideAllScreen();
       
       
        document.querySelector("#intro_scr").classList.add('active');

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        document.querySelector("#intro_scr video").currentTime=0;
        document.querySelector("#intro_scr video").play();
        //showCarSelection
    }
    createLevel() {
        this.gameScene = new GameScene(this, this.camera);
        this.gameScene.init(this.gui);
        this.playerCar = new PlayerCar(this);
        this.playerCar.init("playerCar");
        this.prepareRoadLanes();
        this.AddAICars();
    }
    playNextLevel() {
        updateClick("nextLevelClick")
        Global.boostActivated = false;
        Global.invinsibleActivated = false;
        document.querySelector(".game_header").classList.remove('active')
        // document.querySelector("#miniMap").classList.remove('active')
        this.events.dispatchEvent({
            type: "GAME_EVENTS",
            message: {
                "event_type": "dispose",
                data: {

                }
            }
        });
        this.events.dispatchEvent({
            type: "GAME_EVENTS",
            message: {
                "event_type": "replay_game",
                data: {

                }
            }
        });


    }
    copyCodeToClipboard() {
        updateClick("couponCodeCopied")
        navigator.clipboard.writeText(Global.couponCode).then(() => {}).catch(err => {});
    }
    onCardSelected(card) {

        document.querySelector("#selectBtn").classList.add("active")
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'select'
                }
            }
        });

        Global.vehicleType = card.id.split("_")[1]
        document.querySelectorAll("#selection_scr .cards .card").forEach((card) => {
            card.classList.remove("active")
        })
        card.classList.add("active")
    }
    onLeaderNext() {
        this.resetRegister();
        this.events.dispatchEvent({
            type: "GAME_EVENTS",
            message: {
                "event_type": "reset_game",
                data: {}
            }
        });
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });

        // this.showHome();
    }
    setUpMap() {
        this.map = new Map(this);
        this.map.init();
    }
    // Event handler for loader events
    onEvents(data) {
        switch (data['message']['event_type']) {
            case "load_complete":
                this.initBtns();
                this.showHome();
                this.setUpGame();
                // this.setUpMap();

                document.querySelector("#splash_scr").classList.remove("active");
                document.querySelector("#game_view").classList.add("active");

                // this.showScoreScreen();
                // Global.vehicleType="Car"
                // this.startGame();
                break;
            case "show_splash":
                this.showSplash();
                break;
            case "start_game":
                // this.triggerFirstCars();
                this.startGameTimer();
                break;
            case "game_over":
                this.onGameFinish();
                break;
        }
    }
    async onGameFinish() {
        Global.couponCode = Global.gameLevel==1?'CRLG-XWBP':Global.gameLevel==2?'CRLG-PWD5':'CRLG-2XHY';

        document.querySelector("#level_complete_scr .code").innerHTML = `Voucher code<br/>${Global.couponCode}`;
 document.querySelector("#level_complete_scr .offer").innerHTML = `${Global.gameLevel==1?10:Global.gameLevel==2?15:20}`;
        Global.gameDataToSent = {
            uid: localStorage.getItem('uuid'),
            gameTry: Global.gameTry,
            [`level${Global.gameLevel}Time`]: Global[`level${Global.gameLevel}Time`],
            'time': Global.level1Time + Global.level2Time + Global.level3Time,
            [`level${Global.gameLevel}Code`]: Global.couponCode,
            'vehicle': Global.vehicleType
        }

        if (Global.gameLevel == 1) {
            saveGameData()
        } else {
            updateGameData()
        }
        document.querySelector(`#BGMusic${Global.gameLevel}`).pause();
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'FinishLine'
                }
            }
        });
        if(Global.gameLevel==3){
            this.events.dispatchEvent({
                type: "SOUND_EVENTS",
                message: {
                    "event_type": "play_sound",
                    data: {
                        'sndKey': 'cheer'
                    }
                }
            });
        } 
        //
        // console.log(`LEVEL ${Global.gameLevel} :::: TIME TAKE: ${Global.level1Time}`)
        if (Global.gameLevel < 3) {
            this.showLevelCompleteDialog();
        } else {
            // this.showScoreScreen();
            this.showLevelCompleted();
        }

        // this.stopTimer();
        // let gameData= await saveGameTime(this.gameTime, EVCars[this.carIndex-1]['name']);
        // Global.rank= gameData.rank;
        // Global.placed= gameData.placed;
        // Global.time= gameData.time;

        // if(Global.placed){
        //     this.events.dispatchEvent({
        //         type: "SOUND_EVENTS",
        //         message: {
        //             "event_type": "play_sound",
        //             data: {
        //                 'sndKey': 'congratulations'
        //             }
        //         }
        //     });
        // }else{
        //     this.events.dispatchEvent({
        //         type: "SOUND_EVENTS",
        //         message: {
        //             "event_type": "play_sound",
        //             data: {
        //                 'sndKey': 'fail'
        //             }
        //         }
        //     });
        // }


        // this.showScore();
    }
    triggerFirstCars(){
        this.AILane1Car1a.startAIMove();
        this.AILane1Car1b.startAIMove();
        this.AILane1Car1c.startAIMove();
        this.AILane1Car1d.startAIMove();
    }
    startGameTimer() {
        document.querySelector(".game_header").classList.add('active')
        // document.querySelector("#miniMap").classList.add('active')
        // this.gameTimer = setInterval(this.updateTime.bind(this), 100);
        // this.events.dispatchEvent({
        //     type: "SOUND_EVENTS",
        //     message: {
        //         "event_type": "stop_sound",
        //         data: {
        //             'sndKey': 'splash'
        //         }
        //     }
        // });
        // this.events.dispatchEvent({
        //     type: "SOUND_EVENTS",
        //     message: {
        //         "event_type": "play_sound",
        //         data: {
        //             'sndKey': 'game'
        //         }
        //     }
        // });
        /*  setTimeout(() => {
             this.events.dispatchEvent({
                 type: "SOUND_EVENTS",
                 message: {
                     "event_type": "stop_sound",
                     data: {
                         'sndKey': 'game'
                     }
                 }
             });
         }, 2000); */
    }
    stopTimer() {
        this.gameTimer && clearInterval(this.gameTimer);
    }
    updateTime() {
        this.gameTime += 100;
        let totalSeconds = Math.floor(this.gameTime / 1000); // Convert to total seconds
        let minutes = Math.floor(totalSeconds / 60); // Calculate total minutes
        let seconds = totalSeconds % 60; // Calculate remaining seconds

        document.querySelector("#info_time .txt").innerHTML = `${minutes<10?'0':''}${minutes}:${seconds<10?'0':''}${seconds}`


    }
    // Event handler for game events
    onGameEvents(data) {
        switch (data['message']['event_type']) {
            case "replay_game":
                this.replayGame(false);
                break;
            case "show_counter":
                this.showStartCounter();
                break;
        }
    }

    // Method to start the game
    setUpGame() {

        //     this.dome= new THREE.Mesh(
        //         new THREE.BoxGeometry(400,400,400),
        //         new THREE.MeshBasicMaterial({
        //             // color:0xff0000,
        //             envMap:Global.assets['cubemap']['0']['asset'],
        //             envMapRotation:3.14,
        //             side:THREE.DoubleSide,
        //             transparent:true,
        //             opacity:1
        //  })
        //     )
        //     this.dome.position.set(0,0,-10)
        //     this.add(this.dome)
        // this.environmentMap = Global.assets['cubemap']['0']['asset'];
        // this.environmentMap.encoding = THREE.sRGBEncoding;
        // this.background = this.environmentMap

        // Dispatching events to create the scene and add the player car
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "create_scene",
                data: {}
            }
        });
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "init_sounds",
                data: {}
            }
        });
    }
    gotoHome(v){
        v.preventDefault();
        Global.gamePaused=false;
        Global.gameLevel = 1;
        Global.level1Time = 0;
        Global.level2Time = 0;
        Global.level3Time = 0;

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        Global.boostActivated = false;
        Global.invinsibleActivated = false;
        document.querySelector(".game_header").classList.remove('active')
        this.events.dispatchEvent({
            type: "GAME_EVENTS",
            message: {
                "event_type": "dispose",
                data: {

                }
            }
        });
        this.createLevel();
            this.events.dispatchEvent({
                type: "GAMESCENE_EVENTS",
                message: {
                    "event_type": "create_scene",
                    data: {}
                }
            });
        document.querySelector(`#BGMusic${Global.gameLevel}`).pause();
        this.showHome();
    }
    quitGame(){
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        if(window.parent){
            window.parent.location.href='https://www.jimmysicedcoffee.com/pages/coffee-break'
        }else{
            window.location.href='https://www.jimmysicedcoffee.com/pages/coffee-break'

        }

        return false;


        Global.gamePaused=false;
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        Global.boostActivated = false;
            Global.invinsibleActivated = false;
            document.querySelector(".game_header").classList.remove('active')
            this.events.dispatchEvent({
                type: "GAME_EVENTS",
                message: {
                    "event_type": "dispose",
                    data: {

                    }
                }
            });
        this.replayGame(false, false)
    }
    restartGame(v){
        v.preventDefault();
        Global.gamePaused=false;
        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        Global.boostActivated = false;
            Global.invinsibleActivated = false;
            document.querySelector(".game_header").classList.remove('active')
            this.events.dispatchEvent({
                type: "GAME_EVENTS",
                message: {
                    "event_type": "dispose",
                    data: {

                    }
                }
            });
        this.replayGame(true, false)
    }
    // Method to handle game replay
    replayGame(isGameTry = false, doIncrement=true) {
        updateClick("replayClick")

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'click'
                }
            }
        });
        this.events.dispatchEvent({
            type: "GAME_EVENTS",
            message: {
                "event_type": "reset_camera",
                data: {

                }
            }
        });
        document.querySelector(".game_header .time").innerHTML = '00:00:00'
        this.initDirectionsSaved = false;
        if (isGameTry) {
            doIncrement && Global.gameTry++;
            Global.gameLevel = 1;
            Global.level1Time = 0;
            Global.level2Time = 0;
            Global.level3Time = 0;
        } else {
            doIncrement && Global.gameLevel++;
        }
        this.createLevel();
            this.events.dispatchEvent({
                type: "GAMESCENE_EVENTS",
                message: {
                    "event_type": "create_scene",
                    data: {}
                }
            });
        if (isGameTry) {
            
            this.showCarSelection(true, true);
        }else{
           
            this.onStart();
        }
        // this.setUpMap();
       
    }

    pauseGame(v){
        v.preventDefault();

        if(!document.querySelector(".game_header").classList.contains("active")) return false;

        Global.gamePaused=true;
        // document.querySelector("#")

        this.showInstruction(false);
    }
    resumeGame(v){
        v.preventDefault();
        Global.gamePaused=false;
        this.hideInstruction();
    }
    updateSounds(v) {
        v.preventDefault();
        Global.soundEnabled = !Global.soundEnabled;


        if (Global.soundEnabled) {
            document.querySelector(`#BGMusic${Global.gameLevel}`).play();
            document.querySelector("#volumeBtn").classList.add("active");
        } else {
            document.querySelector(`#BGMusic${Global.gameLevel}`).pause();
            document.querySelector("#volumeBtn").classList.remove("active");
        }
    }
    // Event handler for window resize
    onResize() {

        // Update sizes
        this.sizes.width = window.innerWidth
        this.sizes.height = window.innerHeight

        Global.sizes= this.sizes

        // Dispatching events to update camera and renderer sizes
        this.events.dispatchEvent({
            type: "CAMERA_EVENTS",
            message: {
                "event_type": "resize",
                data: {
                    "aspect": this.sizes.width / this.sizes.height,
                    "sizes": this.sizes
                }
            }
        });
        if (window.innerWidth > window.innerHeight) {
            document.querySelector("#rotate").classList.remove("active");
        } else {
            document.querySelector("#rotate").classList.add("active");
        }
        // Updating renderer size and pixel ratio
        this.renderer.setSize(this.sizes.width, this.sizes.height)
        this.renderer.setPixelRatio(Math.min(Math.max(2, window.devicePixelRatio), isMobile ? 1.5 : 2.0))
    }

    // Update method to render the scene and dispatch update events
    update(now, delta) {
       

   
   
        
        // Configure the overlay camera to render only layer 1
        
        // Render the main scene
       
        
        this.renderer.render(this, this.skyboxCamera)

        this.renderer.render(this, this.camera);
       

     
    //  /*     */
      
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "update",
                data: {
                    "delta": delta,
                    "camera": this.camera,
                    "now": now
                }
            }
        });
    }

    // Game loop function
    tick(now) {
        // this.stats && this.stats.begin();

        // Calculating delta time and frame rate
        const delta = (now - lastTime) / 1000; // Convert milliseconds to seconds
        lastTime = now;

        frameCount++;
        if (delta) {
            fps = frameCount / delta;
            frameCount = 0;
        } else {}

        // Limiting the number of ticks and updating global variables
        let ticks = Math.ceil(delta / (1 / 120));
        ticks = Math.min(ticks, 20);
        Global.fps = new THREE.Vector3(0, Global.fps, 0).lerp(new THREE.Vector3(0, fps, 0), .1).y;
        // lastDeltaVec.lerp(new THREE.Vector3(0, Math.min((delta ? Math.min(delta * 100, 1) : 1) * (120 / (fps || 1)), 10), 0), .1);
        // Global.delta = lastDeltaVec.y;
        const newDelta = Math.min((delta ? Math.min(delta * 100, 1) : 1) * (120 / (fps || 1)), 10);
        Global.delta = THREE.MathUtils.lerp(Global.delta, newDelta, 0.01);

        // Calling the update method and ending the stats tracking
        this.update(now, lastDeltaVec.y);
        // this.stats && this.stats.end();

        // Requesting the next frame
        window.requestAnimationFrame(this.tick.bind(this))
    }
    // activateFullscreenToggle() {
    //     if(!document.querySelector("#toggle_expand").classList.contains("active")){
    //         document.querySelector("#toggle_expand").classList.add("active")
    //         document.querySelector("#toggle_expand").addEventListener("click", this.toggleFullScreen.bind(this))
    //         this.toggleFullScreen();
    //     }

    // }
    toggleFullScreen() {
        if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
            // If currently in fullscreen, exit fullscreen
            this.exitFullscreen();
        } else {
            // If not in fullscreen, request fullscreen for the document's body
            this.requestFullscreen(document.body);
        }
    }

    requestFullscreen(element) {
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    }
    exitFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }
}

// Creating an instance of the Game class and initializing the game
window.onload = async function () {
    localStorage.setItem('uuid', uuidv4())
    Global.userId = localStorage.getItem('uuid');
    await createUser();

    if(!isMobile){
        document.querySelector("#how_to_play .instr .card:nth-child(1) img").src=`https://www.jimmysarcade.co.uk/ui/Instr/InstA-01-Desktop.png`;
        document.querySelector("#how_to_play .instr .card:nth-child(2) img").src=`https://www.jimmysarcade.co.uk/ui/Instr/InstB-01-Desktop.png`;
        document.querySelector("#how_to_play .instr .card:nth-child(3) img").src=`https://www.jimmysarcade.co.uk/ui/Instr/InstC-01-Desktop.png`;
        // document.querySelector("#how_to_play .instr .card:nth-child(4) img").src=`/ui/Instr/InstD-01-Desktop.png`;
    }

    const response = await fetch("https://www.jimmysarcade.co.uk/intro.mp4", {
        method: 'GET',
        mode: 'cors' // CORS must be allowed on server
      });
  
      if (!response.ok) {
        throw new Error("Failed to load video");
      }
  
      const videoBlob = await response.blob();
      const videoURL = URL.createObjectURL(videoBlob);
  
      const videoElement = document.getElementById("intro_vid");

      const audioElement1 = document.getElementById("BGMusic1");
      const audioElement2 = document.getElementById("BGMusic2");
      const audioElement3 = document.getElementById("BGMusic3");
      videoElement.src = videoURL;

      const response1 = await fetch("https://www.jimmysarcade.co.uk/sounds/BG1.mp3", {
        method: 'GET',
        mode: 'cors' // CORS must be allowed on server
      });
      const response2 = await fetch("https://www.jimmysarcade.co.uk/sounds/BG2.mp3", {
        method: 'GET',
        mode: 'cors' // CORS must be allowed on server
      });
      const response3 = await fetch("https://www.jimmysarcade.co.uk/sounds/BG3.mp3", {
        method: 'GET',
        mode: 'cors' // CORS must be allowed on server
      });

      const audioBlob1 = await response1.blob();
      const audioURL1 = URL.createObjectURL(audioBlob1);

      const audioBlob2 = await response2.blob();
      const audioURL2 = URL.createObjectURL(audioBlob2);

      const audioBlob3 = await response3.blob();
      const audioURL3 = URL.createObjectURL(audioBlob3);

      audioElement1.src = audioURL1;
      audioElement2.src = audioURL2;
      audioElement3.src = audioURL3;


          
    const game = new Game();
    game.init();

}